import * as yup from "yup";
import { BASIC_AUTHENTICATION_ERROR } from "../constants/errorMessages";
import REGEX from "../constants/constants";

const { POSITIVE_PATTERN, WEBSITE_PATTERN } = REGEX;

const isFirstVariant = (index) => index === 0;
const isAnyFieldFilled = (variant) => {
  return Object.values(variant).some((value) => {
    if (Array.isArray(value)) return value?.length > 0;
    if (typeof value === "object" && value !== null)
      return Object.keys(value)?.length > 0;
    return !!value;
  });
};

export const CreateProfileSchema = yup.object({
  brandName: yup
    .string()
    .trim()
    .required(BASIC_AUTHENTICATION_ERROR.BRAND_NAME_REQUIRED)
    .max(
      40,
      BASIC_AUTHENTICATION_ERROR.MAX_CHARECTERS.replace(
        "{{NAME}}",
        "Brand Name"
      )
    ),
  website: yup
    .string()
    .trim()
    .required(BASIC_AUTHENTICATION_ERROR.WEBSITE_MATCH)
    .matches(WEBSITE_PATTERN, BASIC_AUTHENTICATION_ERROR.WEBSITE_MATCH),
  bio: yup
    .string()
    .trim()
    .required(BASIC_AUTHENTICATION_ERROR.BIO_REQUIRED)
    .max(
      500,
      BASIC_AUTHENTICATION_ERROR.BIO_MAX_REQUIRED.replace("{{name}}", "Bio")
    ),
  brandWriteUp: yup
    .string()
    .trim()
    .required(BASIC_AUTHENTICATION_ERROR.BRAND_BIO_REQUIRED)
    .max(
      500,
      BASIC_AUTHENTICATION_ERROR.BIO_MAX_REQUIRED.replace(
        "{{name}}",
        "Brand bio"
      )
    ),
  favAboutNYC: yup
    .string()
    .trim()
    .nullable()
    .notRequired()
    .max(
      500,
      BASIC_AUTHENTICATION_ERROR.BIO_MAX_REQUIRED.replace(
        "{{name}}",
        "Favorite thing about NYC"
      )
    ),
  productsProcesses: yup
    .string()
    .trim()
    .nullable()
    .notRequired()
    .max(
      500,
      BASIC_AUTHENTICATION_ERROR.BIO_MAX_REQUIRED.replace(
        "{{name}}",
        "Products/Processes"
      )
    ),
});

export const PaymentSetupSchema = yup.object({});

export const InventorySetupSchema = yup.object({
  productName: yup
    .string()
    .trim()
    .required(BASIC_AUTHENTICATION_ERROR.PRODUCT_NAME_REQUIRED),
  Categories: yup
    .array()
    .required(BASIC_AUTHENTICATION_ERROR.CATEGORIES_REQUIRED)
    .min(1, BASIC_AUTHENTICATION_ERROR.CATEGORIES_REQUIRED),
  status: yup.string().required(BASIC_AUTHENTICATION_ERROR.STATUS_REQUIRED),
  tags: yup
    .array()
    .required(BASIC_AUTHENTICATION_ERROR.TAGS_REQUIRED)
    .min(1, BASIC_AUTHENTICATION_ERROR.TAGS_REQUIRED),
  description: yup
    .string()
    .transform((value, originalValue) =>
      originalValue.trim() === "" ? null : value
    )
    .trim()
    .nullable()
    .notRequired()
    .min(4, BASIC_AUTHENTICATION_ERROR.DESCRIPTION_MIN_REQUIRED)
    .max(500, BASIC_AUTHENTICATION_ERROR.DESCRIPTION_MAX_REQUIRED),
  priceinUSD: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.PRICE_REQUIRED)
    .test(
      "max-digits",
      BASIC_AUTHENTICATION_ERROR.PRICE_MAX_ALLOWED,
      (value) => (value ? /^\d{1,5}(\.\d{2})?$/.test(value) : true)
    )
    .matches(/^\d{1,5}(\.\d{2})?$/, BASIC_AUTHENTICATION_ERROR.PRICE_POSITIVE),
  totalQuantity: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.TOTAL_QUANTITY_REQUIRED)
    .matches(
      POSITIVE_PATTERN,
      BASIC_AUTHENTICATION_ERROR.TOTAL_QUANTITY_MAX_LIMIT
    )
    .test(
      "max-digits",
      BASIC_AUTHENTICATION_ERROR.TOTAL_QUANTITY_MAX_LIMIT,
      (value) => {
        if (!value) return false;
        const num = Number(value);
        return num >= 0;
      }
    ),
  productMedia: yup
    .array()
    .required("Media file is mandatory.")
    .min(1, "Media file is mandatory."),
  variants: yup.array().of(
    yup.object().shape({
      selectSize: yup
        .object()
        .transform((value, originalValue) =>
          originalValue === "" ? null : value
        )
        .nullable()
        .test(
          "variant-validation",
          BASIC_AUTHENTICATION_ERROR.SIZE_REQUIRED,
          function (value) {
            const { parent, options } = this;
            const index = options.index;
            return isFirstVariant(index) || isAnyFieldFilled(parent)
              ? !!value
              : true;
          }
        ),

      selectColor: yup
        .object()
        .transform((value, originalValue) =>
          originalValue === "" ? null : value
        )
        .nullable()
        .test(
          "variant-validation",
          BASIC_AUTHENTICATION_ERROR.COLOR_REQUIRED,
          function (value) {
            const { parent, options } = this;
            const index = options.index;
            return isFirstVariant(index) || isAnyFieldFilled(parent)
              ? !!value
              : true;
          }
        ),

      selectImage: yup
        .array()
        .min(1, BASIC_AUTHENTICATION_ERROR.VARIENT_IMAGE_REQUIRED)
        .test(
          "variant-validation",
          BASIC_AUTHENTICATION_ERROR.VARIENT_IMAGE_REQUIRED,
          function (value) {
            const { parent, options } = this;
            const index = options.index;
            return isFirstVariant(index) || isAnyFieldFilled(parent)
              ? value?.length > 0
              : true;
          }
        ),

      varientQuantity: yup
        .string()
        .matches(POSITIVE_PATTERN, BASIC_AUTHENTICATION_ERROR.QUANTITY_MAX_LIMIT)
        .test(
          "variant-validation",
          BASIC_AUTHENTICATION_ERROR.QUANTITY_REQUIRED,
          function (value) {
            const { parent, options } = this;
            const index = options.index;
            return isFirstVariant(index) || isAnyFieldFilled(parent)
              ? !!value
              : true;
          }
        )
        .test(
          "max-digits",
          BASIC_AUTHENTICATION_ERROR.QUANTITY_MAX_LIMIT,
          (value) => {
            if (!value) return false;
            const num = Number(value);
            return num >= 0 && num <= 500;
          }
        ),
    })
  ),
});

export const EditProfileSchema = yup.object({
  bio: yup
    .string()
    .trim()
    .required(BASIC_AUTHENTICATION_ERROR.BIO_REQUIRED)
    .max(
      500,
      BASIC_AUTHENTICATION_ERROR.BIO_MAX_REQUIRED.replace("{{name}}", "Bio")
    ),
  brandWriteUp: yup
    .string()
    .trim()
    .required(BASIC_AUTHENTICATION_ERROR.BRAND_BIO_REQUIRED)
    .max(
      500,
      BASIC_AUTHENTICATION_ERROR.BIO_MAX_REQUIRED.replace(
        "{{name}}",
        "Brand bio"
      )
    ),
  favAboutNYC: yup
    .string()
    .trim()
    .nullable()
    .notRequired()
    .max(
      500,
      BASIC_AUTHENTICATION_ERROR.BIO_MAX_REQUIRED.replace(
        "{{name}}",
        "Favorite thing about NYC"
      )
    ),
  productsProcesses: yup
    .string()
    .trim()
    .nullable()
    .notRequired()
    .max(
      500,
      BASIC_AUTHENTICATION_ERROR.BIO_MAX_REQUIRED.replace(
        "{{name}}",
        "Products/Processes"
      )
    ),
});
